import React, { useEffect, useState } from 'react';
import SourcesAPI from './SourcesAPI';
import { useFeatureFlagContext } from '../../Context/FeatureFlagContext/FeatureFlagContext';

export const SPREAD_SHEET_LINK_TEXT = {
  GENERATE: 'Generate Google Docs Spreadsheet',
  VIEW: 'View Google Docs Spreadsheet',
};

const SpreadsheetLink = () => {
  const [companyId, setCompanyId] = useState();
  const [spreadSheetUrl, setSpreadSheetUrl] = useState();

  const { isAdminGoogleSpreadsheetEnabled } = useFeatureFlagContext();

  const fetchSpreadsheetUrl = async () => {
    const { spreadsheet_url, company_id } =
      await SourcesAPI.getSpreadsheetUrl();

    setCompanyId(company_id);
    setSpreadSheetUrl(spreadsheet_url);
  };

  useEffect(() => {
    fetchSpreadsheetUrl();
  }, []);

  const refreshPageUrl = `/refresh-spreadsheet/${companyId}`;

  const primaryLinkText = spreadSheetUrl
    ? SPREAD_SHEET_LINK_TEXT.VIEW
    : SPREAD_SHEET_LINK_TEXT.GENERATE;

  const primaryLinkUrl = spreadSheetUrl || refreshPageUrl;

  return (
    <div>
      <a
        className="spreadsheet-link"
        href={primaryLinkUrl}
        target="_blank"
        rel="noreferrer"
      >
        {primaryLinkText}
      </a>

      {primaryLinkText === SPREAD_SHEET_LINK_TEXT.VIEW &&
        isAdminGoogleSpreadsheetEnabled && (
          <React.Fragment>
            <span className="spreadsheet-divider">|</span>
            <a
              className="spreadsheet-link"
              href={refreshPageUrl}
              target="_blank"
              rel="noreferrer"
            >
              <i className="fa fa-sm fa-arrows-rotate refresh-icon" />
              Refresh Spreadsheet
            </a>
          </React.Fragment>
        )}
    </div>
  );
};

export default SpreadsheetLink;
